import { AnyAction, Dispatch } from 'redux';
import { DEFAULT_SOUNDTRACK_VOLUME_LEVEL } from '../../../constants/app-constants';
import AnalyticsEventUtil from'../../../infra/analytics/analytics-event-util';
import { disableMusic, enableMusic, selectIsMusicEnabled, setSoundtrackVolume } from '../../../store/selectors/global.selector';
import { AppState } from '../../../store/store';
import { ThunkResult } from '../shared/ThunkResult';

export const soundIconClicked = (): ThunkResult<void> => {
  return (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    const isMusicOn = selectIsMusicEnabled(getState());
    AnalyticsEventUtil.getInstance().soundIconClicked(isMusicOn);
    dispatch({ type: 'SET_USER_HAS_INTERACTED', payload: true });
    if (isMusicOn) {
      dispatch(setSoundtrackVolume(0));
      dispatch(disableMusic());
    } else {
      dispatch(setSoundtrackVolume(DEFAULT_SOUNDTRACK_VOLUME_LEVEL));
      dispatch(enableMusic());
    }
  };
};
